angular.module('app').factory('DateRangePickerService', function () {
    let fac = { options: options };
    return fac;
    function options() {
        let options = {
            applyClass: 'btn-info',
            showDropdowns: true,
            singleDatePicker: false,
            linkedCalendars: false,
            alwaysShowCalendars: false,
            locale: {
                applyLabel: 'Apply',
                fromLabel: 'From',
                format: 'DDMMMYY',
                toLabel: 'To',
                cancelLabel: 'Cancel',
                customRangeLabel: 'Custom range'
            },
            // NOTE: The first couple of lines seem to fix an issue where
            // selecting Today does not set a date range???
            ranges: {
                'Date ranges': [moment(), moment()],
                Today: [
                    moment()
                        .subtract(1, 'days')
                        .add(1, 'days'),
                    moment().subtract(0, 'days')
                ],
                Yesterday: [
                    moment().subtract(1, 'days'),
                    moment().subtract(1, 'days')
                ],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'This Month': [
                    moment().startOf('month'),
                    moment().endOf('month')
                ],
                'Last Month': [
                    moment()
                        .subtract(1, 'month')
                        .startOf('month'),
                    moment()
                        .subtract(1, 'month')
                        .endOf('month')
                ]
            }
        };
        return options;
    }
});
